
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { PROJECT_STATUS } from '../../common/common/project/status';
import Text from '../../common/client/components/Text';

import { getToken } from '../../reducers/auth';
import { getProjectId, getProjectStatus } from '../../reducers/project';
import projectGetActions from '../../sagas/project';
import LoginInfo from '../auth/LoginInfo';
import ProjectBussy from '../common/ProjectBussy';
import OverviewPanelCategory from './OverviewPanelCategory';
import OverviewPanelInputData from './OverviewPanelInputData';
import OverviewPanelImportError from './OverviewPanelImportError';
import ProjectCommandBar from './ProjectCommandBar';

const classNames = mergeStyleSets({
    projectOverview: {
        paddingLeft: 16
    },
    title: {
        paddingRight: 32
    },
    loginInfo: {
        paddingRight: 14
    }
});

const ProjectOverviewContent = (props) => {

    switch (props.projectStatus) {
        case PROJECT_STATUS.READY.value:
            return (
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <OverviewPanelInputData />
                    <OverviewPanelCategory />
                </Stack>
            );

        case PROJECT_STATUS.IMPORT_KU_DATA.value:
            return <ProjectBussy title="Probíhá import katastrálních dat, čekejte prosím..."/>;

        case PROJECT_STATUS.UPDATE_DATA_FROM_SOURCE.value:
            return <ProjectBussy title="Probíhá aktualizace dat ze zdroje, čekejte prosím..."/>;

        case PROJECT_STATUS.IMPORT_KU_DATA_ERROR.value:
            return (
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <OverviewPanelImportError />
                </Stack>
            );

        default:
            break;
    }
}

const ProjectOverview = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const token = useSelector(state => getToken(state));
    const projectId = useSelector(state => getProjectId(state));
    const projectStatus = useSelector(state => getProjectStatus(state));

    const checkAutorefresh = () => {
        let canRunAutorefresh = (projectStatus === PROJECT_STATUS.IMPORT_KU_DATA.value)

        if (canRunAutorefresh) {
            // ToDo: clear timeout on leave page
            setTimeout(() => {
                projectActions.refresh(token, projectId);
            }, 30 * 1000);
        }
    }

    useEffect(() => {
        checkAutorefresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.project]);

    return (
        <Stack verticalFill className={classNames.projectOverview}>
            <Stack.Item>
                <Stack horizontal verticalAlign="baseline">
                    <Stack.Item grow className={classNames.title}>
                        <Text mega>{props.project.data.project.title}</Text>
                    </Stack.Item>
                    <Stack.Item align="start">
                        <div className={classNames.loginInfo}>
                            <LoginInfo />
                        </div>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <ProjectCommandBar project={props.project} />
            </Stack.Item>
            <Stack.Item grow>
                <ProjectOverviewContent projectStatus={projectStatus} />
            </Stack.Item>
        </Stack>
    );
}

export default ProjectOverview;
